import React, { useState } from "react";

const ContractForm = ({setFormData}) => {
  const [minDuration, setMinDuration] = useState(3);
  const [noticePeriod, setNoticePeriod] = useState("3 months");
  const [earlyLeavingType, setEarlyLeavingType] = useState("Multiple of Rent");
  const [earlyLeavingMonths, setEarlyLeavingMonths] = useState(0);
  const [fixedAmount, setFixedAmount] = useState(0);


  const [houseRules, setHouseRules] = useState({
    petsAllowed: false,
    visitorsAllowed: false,
    smokingAllowed: false,
    alcoholAllowed: false,
    partyAllowed: false,
    lastEntryTime: "8:30 PM",
    otherRules: "",
  });

  const [propertyDescription, setPropertyDescription] = useState("");

  const handleRuleChange = (rule, value) => {
    const updatedRules = { ...houseRules, [rule]: value };
    setHouseRules(updatedRules);
    updateParentFormData({ houseRules: updatedRules });
  };


  const updateParentFormData = (updatedData) => {
    setFormData((prev) => ({
      ...prev,
      pricingAndOthers: {
        ...prev.pricingAndOthers,
        ContractForm:{
          ...prev.ContractForm,
          minDuration,
          noticePeriod,
          earlyLeavingType,
          earlyLeavingMonths,
          fixedAmount,
          houseRules,
          propertyDescription,
          ...updatedData, // Overwrite specific updated data
        }
        
      },
    }));
  };


  return (
    <div className="">
      <h2 className="text-lg font-semibold mb-4">Contract Settings</h2>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Minimum Contract Duration */}
      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">Minimum contract duration (Optional)</label>
        <select
          className="w-full border rounded-md px-3 py-2"
          value={minDuration}
          onChange={(e) => {
            setMinDuration(e.target.value);
            updateParentFormData({ minDuration: e.target.value });
          }}
        >
          {[...Array(12).keys()].map((num) => (
            <option key={num} value={num + 1}>
              {num + 1} month{num > 0 ? "s" : ""}
            </option>
          ))}
        </select>
      </div>

      {/* Months of Notice */}
      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">Months of Notice (Optional)</label>
        <div className="flex gap-2 flex-wrap">
          {["None", "1 month", "2 months", "3 months", "4 months", "5 months", "6 months"].map((option) => (
            <button
              type="button"
              key={option}
              className={`px-2 py-1 text-sm border rounded-md ${
                noticePeriod === option ? "bg-blue-500 text-white" : "bg-white text-gray-700"
              }`}
              onClick={() => {
                setNoticePeriod(option);
                updateParentFormData({ noticePeriod: option });
              }}
            >
              {option}
            </button>
          ))}
        </div>
      </div>

      {/* Early Leaving Charges */}
      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">Early leaving charges (Optional)</label>
        <div className="flex gap-2 mb-3">
          {["None", "Fixed", "Multiple of Rent"].map((type) => (
            <button
            type="button"
              key={type}
              className={`px-2 py-1 text-sm border rounded-md ${
                earlyLeavingType === type ? "bg-blue-500 text-white" : "bg-white text-gray-700"
              }`}
              onClick={() => {
                setEarlyLeavingType(type);
                updateParentFormData({ earlyLeavingType: type });
              }}
            >
              {type}
            </button>
          ))}
        </div>
        {earlyLeavingType === "Multiple of Rent" && (
          <div>
            <label className="block text-sm mb-1">Enter no. of Months</label>
            <input
              type="number"
              className="w-full border rounded-md px-3 py-2"
              value={earlyLeavingMonths}
              onChange={(e) => {
                setEarlyLeavingMonths(e.target.value);
                updateParentFormData({ earlyLeavingMonths: e.target.value });
              }}
              min={0}
              max={6}
            />
            <p className="text-sm text-gray-500 mt-1">This should be between 0-6 months</p>
          </div>
        )}
        {earlyLeavingType === "Fixed" && (
          <div>
            <label className="block text-sm mb-1">Enter Fixed Amount</label>
            <input
              type="number"
              className="w-full border rounded-md px-3 py-2"
              value={fixedAmount}
              onChange={(e) => {
                setFixedAmount(e.target.value);
                updateParentFormData({ fixedAmount: e.target.value });
              }}
              min={0}
            />
            <p className="text-sm text-gray-500 mt-1">Enter a valid fixed amount</p>
          </div>
        )}
      </div>


       {/* House Rules */}
       <div className="mb-4">
        <label className="block text-sm font-medium mb-2">Some house rules (Optional)</label>
        {[
          { label: "Pets allowed", key: "petsAllowed" },
          { label: "Visitors allowed", key: "visitorsAllowed" },
          { label: "Smoking allowed", key: "smokingAllowed" },
          { label: "Alcohol allowed", key: "alcoholAllowed" },
          { label: "Party/Event allowed", key: "partyAllowed" },
        ].map((rule) => (
          <div key={rule.key} className="flex items-center mb-2">
            <span className="w-1/2 text-sm">{rule.label}</span>
            <div className="flex gap-4">
              <label className="flex items-center">
                <input
                  type="radio"
                  name={rule.key}
                  value="yes"
                  checked={houseRules[rule.key] === true}
                  onChange={() => handleRuleChange(rule.key, true)}
                  className="mr-1"
                />
                Yes
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  name={rule.key}
                  value="no"
                  checked={houseRules[rule.key] === false}
                  onChange={() => handleRuleChange(rule.key, false)}
                  className="mr-1"
                />
                No
              </label>
            </div>
          </div>
        ))}
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Last entry time</label>
          <select
            className="w-full border rounded-md px-3 py-2"
            value={houseRules.lastEntryTime}
            onChange={(e) => handleRuleChange("lastEntryTime", e.target.value)}
          >
            {["6:00 PM", "7:00 PM", "8:00 PM", "9:00 PM", "10:00 PM"].map((time) => (
              <option key={time} value={time}>
                {time}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Have any other rule?</label>
          <textarea
            className="w-full border rounded-md px-3 py-2"
            rows={3}
            value={houseRules.otherRules}
            onChange={(e) => handleRuleChange("otherRules", e.target.value)}
            placeholder="Type any other rules that guests should follow..."
          ></textarea>
        </div>

         {/* Property Description */}
      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">What makes your property unique</label>
        <textarea
          className="w-full border rounded-md px-3 py-2"
          rows={5}
          placeholder="Share some details about your property like spacious rooms, well-maintained facilities..."
          value={propertyDescription}
          onChange={(e) => {
            setPropertyDescription(e.target.value);
            updateParentFormData({ propertyDescription: e.target.value });
          }}
        ></textarea>
        <p className="text-sm text-gray-500 mt-1">
          Minimum 30 characters required <span className="float-right">{propertyDescription.length}/5000</span>
        </p>
      </div>
      </div>
    </div>
  );
};

export default ContractForm;
